// Include React Modules
import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import Swal from "sweetalert2";
// Containers
import App from '../App'
// Routes
import Login from '../containers/Login/index.login';
import Register from '../containers/Login/index.register';
import { Auth } from 'aws-amplify';
import { history } from '../store.js';
import DataHqCompany from "../Controls/Select/DataHqCompany";

export default loadRootRoutes => {

    return (
        <Switch>
            {/* Routes defined in here will load into the root */}
            <PrivateRoute path="/login" component={Login} exact={true} />
            <PrivateRoute  path="/register" component={Register} exact={true}/>
            <Route path="/" component={App} />
        </Switch>
    );
};

class PrivateRoute extends Component {
    async componentDidMount() {
        try {
            const user = await Auth.currentAuthenticatedUser();
            const list_group = user.signInUserSession.accessToken.payload['cognito:groups'];
            let is_user_hq = false;
            
            if(list_group){
                list_group.map((group_value, index) => {
                    if (group_value == 'hq') {
                        is_user_hq = true;
                    }
                })
            }
            
            if (is_user_hq != true) {
                if (user) {
                    if (user.attributes['custom:is_approve'] == '0') {
                        DataHqCompany.map((values, index) => {
                            let company_email = user.attributes['custom:company_email'];
                            let companyEmail = company_email.split(',');
                            companyEmail.forEach((email) => {
                                if (email.includes(values.value)) {
                                    throw ({ message: 'Pending user validation from HQ, please contact your HQ for Verification' });
                                }    
                            });
                        });
                    }
                }
            }
            history.push('/home');
        } catch (e) {
            // Swal.fire(
            //     'Error',
            //     e.message,
            //     'error'
            // )
            const status = await Auth.signOut();
            history.push('/login');
        }
    }
    render() {
        const { component, path } = this.props;
        return (
            <Route path={path} component={component} exact={true} />
        );
    }
}

// class PrivateRoute extends Component {
//     async componentDidMount() {
//         try {
//             if (await Auth.currentAuthenticatedUser()) {
//                 history.push('/home');
//             }
//         } catch (e) {
//             console.error(e);
//             history.push('/login');
//         }
//     }
//     render() {
//         const { component, path } = this.props;
//         return (
//             <Route path={path} component={component} exact={true} />
//         );
//     }
// }


// WEBPACK FOOTER //
// ./src/routes/initialRoute.js